import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-llama31',
  templateUrl: './llama31.component.html',
  styleUrls: ['./llama31.component.scss']
})
export class Llama31Component {
  constructor(private dialogRef: MatDialogRef<Llama31Component>) {}

  close(): void {
    this.dialogRef.close();
  }
}
